<script>
  import Logo from "./Logo.svelte";
  import Privacy from "./Privacy.svelte";

  let showPrivacy = false;
  let mostrarLogo = false;

  let idioma;
  let prefLang = "EN"; 
  console.log(prefLang);
  if (prefLang == "EN") {
    idioma = "ES"
  } else {
    idioma = "EN"
  }

  let texto = {
    EN: {
      nav: { one: "Method", two: "Videos", three: "Team", four: "Contact"},
      quote1: '"The spine as the axis of life"',
      method: {
        title: "Columna Vitae Method",
        sub1: {
          title: "Introduction & Fundamentals",
          p1: `It is an ancient, manual and medical assistance technique with contributions from 
          non-traditional Tibetan medicine, older than osteopathy and chiropractic.`,
          p2: `It consists of a non-invasive manual praxis that is performed on the spinal column, 
          acting on the reflex pathways that run along it and on the nerve roots that emerge from it.`,
          aclaratorio: `In the '80s, Dr. Carlos M. Fiore refined and deepened this method by incorporating 
          principles of neuroanatomy, neurophysiology and human biomechanics, thus making it a `,
          bold: '"medical assistance method".'
        },
        sub2: {
          title: "Goals",
          p1: `Our main objective is to improve the quality life of patients and avoid the invasive treatments 
          to which they are currently subjected where the results in a high percentage are not satisfactory, 
          causing the patient a disability and therefore an alteration in the development of his life.`,
          p2: `Our project aims at the maximum well-being of patients with pathologies of the spine, citing 
          lumbar pains as the most important example, as well as adolescent cervical pain, cervicobrachialgia 
          (pain from the brachial plexus C5-D2), scoliosis and kyphosis, among others, which cause significant 
          pain in the affected region on different magnitude.`, 
          p3: `Generally these pains are caused by minor intervertebral displacements (MID) which can be addressed 
          manually and above all non-invasively.`,
          p4: `We have verified through our experience of consultations, that the treatments carried out in 
          a moderately invasive way (blockages, infiltrations, ozone therapy, etc.) or invasive (surgeries 
          such as laminectomies, fixations with screws and plates, bars with screws, etc.), could be avoided 
          in a high percentage.`,
          p5: `We understand the need to comprehensively encompass the patient, which implies taking into 
          account factors such as biomechanics, the psyche, and the generation of confidence of the patient 
          towards the treatment, which collaborates to a great extent in accelerating the recovery process.`,
          p6A: `On the other hand, educate the patient of the usual causes that generate `,
          p6Em: "vertebral displacements*",
          p6B: ` such as bad postures, exposure to cold, significant efforts and distress.`,
          aclaratorioSpan: `* Vertebral Displacements: `,
          aclaratorioP: `They are the main cause of compression on the nerve roots that lead to symptoms such 
          as pain, numbness, stiffness, limitation of movement, etc. and consequently they can affect 
          the psychomotor functioning, energy flow, emotional state and personal mood.`
        },
        sub3: {
          title: "Advantages and Scopes",
          b1: `It covers patients of all ages, from early childhood to old age.`,
          b2: `It provides medical therapy especially to those who cannot receive 
          pharmacological treatments.`,
          b3: `It allows the approach of patients who are not subject to invasive and / 
          or surgical treatments, as it is a non-invassive manual method.`,
          b4: `It is exempt from adverse reactions.`,
          b5: `It has no contraindications.`,
          b6: `It is ambulatory.`
        },
        sub4: {
          title: `Business Area`,
          p1: `Since pathologies linked to the spine are highly prevalent -they affect about 80% of the 
          world population and constitute one of the main causes of consultation both: in the emergency 
          and on an outpatient basis for many medical specialties- the "Columna Vitae" method allows the 
          reduction of health costs in multiple aspects:`,
          b1: `The consumption of drugs (analgesics, corticosteroids, non-steroidal anti-inflammatory drugs, 
          opioids, etc.) is canceled or decreased by reducing their doses and the time of treatment.`,
          b2: `Spinal and / or peripheral surgeries (derived from conditions in the spine) are avoided in a 
          high percentage, and therefore there's a reduction of hospitalization and rehabilation times, and further complications.`,
          b3: `Accelerates the recovery process and therefore the return to work.`,
          b4: `The rate of work absenteeism is decreased, since neck and back pain are among the leading 
          causes of absenteeism and comprise more than 50% of all cases.`
        },
        sub5: {
          title: "Pathologies",
          subtitle: "Frequent pathologies that are treated with Columna Vitae:",
          b1: "Cervicalgias (dizziness, vertigo, headaches, instability, etc.)",
          b2: `Cervicobrachialgias (pain and reduced movility in shoulders, 
          numbness in arms and / or hands, carpal tunnel, tennis and golfer's elbow,
          rotator cuff)`,
          b3: "Back Pain",
          b4: "Lower Back Pain",
          b5: "Lumbar Sciatic Pain (heel pain, metatarsus pain, etc.)",
          b6: "Discopathies",
          b7: "Herniated Discs",
          b8: "Disc Protrusions",
          b9: "Spondilolysis",
          b10: "Spondylolisthesis",
          b11: "Coccyx Pain",
          b12: "Trochanteritis",
          b13: "Groin pain",
          b14: "Hallux Valgus (Bunions)",
          b15: "Ankle sprains",
          b16: "Flatfoot",
          b17: "Plantar Faciitis"
        }
      },
      quote2: '"The structural governs the functional"',
      quote3: '"The secret to a healthy spine is to be like a bamboo pole: flexible and strong."',
      videos: "Videos -in Spanish-",
      team: {
        title: "Columna Vitae Team",
        fioreName: "Dr. Carlos Mario Fiore",
        fioreTitle: "Medical Director and creator of the Method",
        fioreText: `Graduated from the Faculty of Medicine of the University of Buenos Aires. 
        He specialized in general and oncological surgery. He is the author of more than 130 scientific 
        works. Member of the Argentine Medical Association. President of the First Argentinean Conference 
        on Pathophysiology of the Vertebral Column. He has taught international seminars in Argentina, 
        Mexico, United States, Spain and Italy.`,
        marcosName: "Marcos Lubos",
        marcosTitle: "Disciple of Dr. Fiore and active member of the Columna Vitae Team since 2012",
        marcosText: `Besides being specialized in the Columna Vitae Method, he studied a variety of Manual 
        Therapies like: Neuromuscular Therapy (Paul St. John School, Florida, USA), Physiotherapy (ULL-Spain), 
        Craneo Sacral Therapy (Los Angeles, USA) and Reflexology (Ingham Method, Florida, USA) among others.`
      },
      contact: {
        title: "Contact Us",
        p1: `Online master classes for practitioners (Email us for further information). We serve in Buenos Aires, 
        Argentina: downtown Microcenter and San Isidro areas.`,
        p2A: "To contact us, send us an ",
        p2Link: "Email",
        p2B: ` or fill in all the fields of the form and press the button to submit it.`,
        p3: `In case of requesting an 
        appointment, leave us a description of the problem. We will get in touch with you.`,
        bold: "OR MAKE AN APPOINTMENT AT:",
        phone: "(+54-911) 3657-4654",
        horarioA: "Monday to Friday from 9 a.m. to 6 p.m.",
        horarioB: "(It's Mobile & WhatsApp)"
      },
      form: {
        name: "Name/s",
        lastName: "Last Name/s",
        phone: "Phone Number",
        text: "Query",
        optionText: "Yes, I want to receive information by email about future offers, promotions and events.",
        send: "Send"
      }
    },

    ES: {
      nav: { one: "Método", two: "Videos", three: "Equipo", four: "Contacto"},
      quote1: '"La columna vertebral como eje de la vida"',
      method: {
        title: "Método Columna Vitae",
        sub1: {
          title: "Orígenes y Fundamentos",
          p1: `Es una técnica médico asistencial, manual y milenaria con aportes de 
          la medicina tibetana no tradicional, más antigua que la osteopatía y la quiropraxia.`,
          p2: `Consiste en una praxis manual no invasiva que se realiza sobre la columna vertebral, 
          que actúa sobre las vías reflejas que transcurren a lo largo de la misma y las raíces 
          nerviosas que emergen de ella.`,
          aclaratorio: `En la década del '80, el Dr. Carlos M. Fiore perfecciona y profundiza 
          dicho método al incorporar principios de neuroanatomía, neurofisiología y biomecánica 
          humana, convirtiéndolo así en un `,
          bold: '"método médico asistencial".'
        },
        sub2: {
          title: "Objetivo",
          p1: `Nuestro objetivo central es mejorar la calidad de vida de los pacientes y evitar los 
          tratamientos invasivos a los cuales son sometidos en la actualidad donde los resultados 
          en un alto porcentaje no son satisfactorios, ocasionándole al paciente una minusvalía y 
          por ende una alteración en el desarrollo de su vida.`,
          p2: `Nuestro proyecto apunta al máximo bienestar de los pacientes con patologías de columna 
          vertebral, citando como ejemplo más importante las lumbalgias y lumbociatalgias, además de 
          las cervicalgias, cervicobraquialgias, escoliosis y cifosis del adolescente, entre otros, 
          los cuales ocasionan dolor importante en la región afectada de diferente magnitud. `, 
          p3: `Generalmente estos dolores son ocasionados por desplazamientos intervertebrales menores 
          (DIM) los cuales pueden ser abordados de manera manual y por sobre todo de manera no agresiva.`,
          p4: `Hemos constatado a través de nuestra experiencia de consultas, que los tratamientos 
          realizados de forma medianamente invasiva (bloqueos, infiltraciones, ozonoterapia, etc.) o 
          invasiva (cirugías como por ejemplo laminectomías, fijaciones con tornillos y placas, barras 
          con tornillos, etc.), en un alto porcentaje podrían ser evitados.`,
          p5: `Comprendemos la necesidad de abarcar integralmente al paciente, lo que implica tener en 
          cuenta factores como la biomécanica, la psiquis, y la generación de confianza del paciente hacia 
          el tratamiento, lo cual colabora en buena medida a acelerar la recuperación del mismo. `,
          p6A: `Por otro lado, concientizar al paciente de las causas habituales que generan `,
          p6Em: "desplazamientos vertebrales*",
          p6B: ` como las malas posturas, exposición al frío, esfuerzos importantes y estrés.`,
          aclaratorioSpan: `* Desplazamientos vertebrales: `,
          aclaratorioP: `Son las principales causas de compresión sobre las raíces nerviosas que derivan 
          en síntomas como dolor, parestecia, rigidez, limitación de movimiento, etc. y consecuentemente 
          puede afectar su funcionamiento psicomotor, el flujo energético, el estado emocional y estado 
          de ánimo personal.`
        },
        sub3: {
          title: "Ventajas y Alcances",
          b1: `Abarca a pacientes de todas las edades, desde la primera infancia 
          hasta la senectud.`,
          b2: `Brinda una terapia médica sobre todo a quienes no pueden recibir 
          tratamientos farmacológicos.`,
          b3: `Permite el abordaje de enfermos no pasibles de tratamientos invasivos 
          y/o quirúrgicos, al ser un método manual no agresivo.`,
          b4: `Se encuentra exento de reacciones adversas.`,
          b5: `No presenta contraindicaciones.`,
          b6: `Es ambulatorio.`
        },
        sub4: {
          title: `Area Empresa`,
          p1: `Dado que las patologías vinculadas a la columna vertebral son altamente prevalentes, 
          ya que llegan a afectar al 80% de la población mundial y constituyen una de las principales 
          causas de consulta tanto en la emergencia como a nivel ambulatorio de numerosas 
          especialidades médicas, el método Columna-Vitae permite la reducción de los costos en salud 
          en múltiples aspectos:`,
          b1: `Se anula o disminuye el consumo de fármacos (analgésicos, corticoides, antiinflamatorios 
          no esteroides, opioides, etc) al reducir las dosis de los mismos y el tiempo de tratamiento.`,
          b2: `Se evita en un alto porcentaje la realización de cirugías de columna y/o periféricas 
          (derivadas de afecciones en la columna vertebral), con la disminución de tiempos de internación 
          y las consiguientes complicaciones de las mismas.`,
          b3: `Acelera el proceso de recuperación y por ende de la reincorporación laboral.`,
          b4: `Se disminuye la tasa de ausentismo laboral, dado que el dolor cervical y de espalda se 
          encuentra entre las primeras causas de ausentismo y comprenden más de un 50% de la totalidad 
          de los casos.`
        },
        sub5: {
          title: "Patologías",
          subtitle: "Patologías frecuentes que se tratan con Columna-Vitae:",
          b1: "Cervicalgias (mareos, vértigo, cefaleas, inestabilidad, etc.)",
          b2: `Cervicobraquialgias (dolor y limitación de moviento en hombros, parestecia en brazos 
          y manos, túnel carpiano, codo de tenista y golfista)`,
          b3: "Dorsalgias",
          b4: "Lumbalgias",
          b5: "Lumbociatalgias (talalgias, metatalalgias, etc.)",
          b6: "Discopatías",
          b7: "Hernias de disco",
          b8: "Protusiones discales",
          b9: "Espondilolisis",
          b10: "Espondilolistesis",
          b11: "Omalgias",
          b12: "Coxalgias",
          b13: "Gonalgias",
          b14: "Inguinocruralgias, etc.",
          b15: "Hallux Valgus (juanetes)",
          b16: "Esguinces de tobillo",
          b17: "Metatarsalgias, talalgias, facitis plantal, etc."
        }
      },
      quote2: '"Lo estructural gobierna lo funcional"',
      quote3: '"El secreto de una columna sana es ser como una caña de bambú: flexible y resistente."',
      videos: "Videos",
      team: {
        title: "Miembros del Equipo Columna Vitae",
        fioreName: "Dr. Carlos Mario Fiore",
        fioreTitle: "Director médico y creador del método",
        fioreText: `Graduado en la Facultad de Medicina de la Universidad de Buenos Aires. Se especializó 
        en cirugía general y oncológica. Es autor de más de 130 trabajos científicos. Miembro de la 
        Asociación Médica Argentina. Presidente de las I Jornadas Argentinas de Fisiopatología de la 
        Columna Vertebral. Ha dictado Seminarios internacionales en la Argentina, México, Estados Unidos, 
        España e Italia.`,
        marcosName: "Marcos Lubos",
        marcosTitle: "Discípulo del Dr. Fiore y miembro activo del equipo Columna Vitae desde el 2012",
        marcosText: `Además de haberse especializado en el Método Columna Vitae, estudió distintas terapias manuales como: Terapia 
        Neuromuscular (Paul St. John School, Florida-EEUU), Fisioterapia (ULL-España), Terapia Cráneo Sacral 
        (Los Angeles-EEUU) y Reflexología (Ingham Method, Florida-EEUU) entre otros.`
      },
      contact: {
        title: "Contacto",
        p1: "Atendemos en Buenos Aires, Argentina, en las zonas de Microcentro y San Isidro.",
        p2A: "Para contactarnos, envíenos un ",
        p2Link: "correo electrónico",
        p2B: ` o complete todos los campos del formulario y presione enviar.`,
        p3: `En caso de solicitar un turno, déjenos una descripción del problema. 
        Nos pondremos en contacto con usted.`,
        bold: "O RESERVE TURNO AL:",
        phone: "(+54-911) 3657-4654",
        horarioA: "de lunes a viernes de 9 a 18 hs",
        horarioB: "(es celular y whatsapp)"
      },
      form: {
        name: "Nombre/s",
        lastName: "Apellido/s",
        phone: "Teléfono",
        text: "Consulta",
        optionText: "Si, deseo recibir información por correo electrónico sobre futuras ofertas, promociones y eventos.",
        send: "Enviar"
      }
    }
  };

  let videos = {
    ES: [
      { title: "Actitud Cifótica - Tratamiento y Evolución", 
        link: "https://www.youtube.com/embed/qJtTIs65xWM?rel=0&modestbranding=1"},
      { title: "Locomoción en Tercera Edad", 
        link: "https://www.youtube.com/embed/37HmTJ41p0M?rel=0&modestbranding=1"},
    ],
    EN: [
      { title: "Kyphotic Attitude CASE", 
        link: "https://www.youtube.com/embed/ulFfYHfH3I0?rel=0&modestbranding=1"},
      { title: "Locomotion on a 93 y.o. man CASE", 
        link: "https://www.youtube.com/embed/F2Z7BmRBNlk?rel=0&modestbranding=1"},
    ]
  }

  function changeLang() {
    if (idioma == "EN") {
      idioma = "ES"
    } else {
      idioma = "EN"
    }
  }

  function animarLogo() {
    mostrarLogo = true;
    setTimeout(() => {
      mostrarLogo = false;
    }, 1400);
  }

</script>

<Logo {mostrarLogo} />

<div class="container">
  <header>
    <svg
      id="LogoCV"
      width="51.227mm"
      height="44.913mm"
      version="1.1"
      viewBox="0 8 50 33"
      xmlns="http://www.w3.org/2000/svg">
      <g aria-label="ISOTIPO" fill="#1aaded" fill-rule="evenodd">
        <ellipse cx="6.132" cy="10.121" rx=".367" ry=".353" />
        <ellipse cx="5.809" cy="11.571" rx=".614" ry=".591" />
        <ellipse cx="5.176" cy="13.511" rx=".91" ry=".875" />
        <ellipse cx="4.488" cy="15.981" rx="1.144" ry="1.1" />
        <ellipse cx="4.426" cy="19.031" rx="1.389" ry="1.337" />
        <ellipse cx="5.333" cy="22.351" rx="1.512" ry="1.454" />
        <ellipse cx="6.49" cy="25.391" rx="1.32" ry="1.27" />
        <ellipse cx="7.367" cy="28.211" rx="1.217" ry="1.171" />
        <ellipse cx="7.542" cy="30.801" rx="1.008" ry=".97" />
        <ellipse cx="6.93" cy="33.081" rx=".77" ry=".741" />
        <ellipse cx="6.168" cy="34.781" rx=".551" ry=".53" />
      </g>
      <g aria-label="COLUMNA">
        <path
          d="M13.646 19.58q-.412.597-1.053.962-.631.365-1.499.365-.825
          0-1.516-.373-.682-.382-1.078-1.054t-.396-1.518q0-.87.387-1.543.388-.68
          1.036-1.053.65-.374 1.399-.374.606 0
          1.07.216.471.216.791.606l.009-.706h.783v1.85l-.556.05q-.606-1.327-1.97-1.327-.548
          0-1.02.282-.463.274-.75.796-.278.515-.278 1.195 0 .647.278
          1.162.278.506.75.796.48.29 1.061.29.682 0
          1.154-.29.48-.29.834-.796zM16.506 20.91q-.581
          0-1.087-.257-.505-.258-.808-.73-.295-.473-.295-1.079
          0-.614.295-1.078.303-.473.808-.73t1.087-.258q.573 0
          1.07.258.505.257.808.73t.303 1.078q0 .606-.294
          1.079-.295.472-.8.73-.498.257-1.087.257zm0-.656q.379 0
          .682-.174.303-.174.472-.49.177-.323.177-.746t-.177-.738q-.169-.324-.472-.498t-.682-.174q-.581
          0-.96.39-.37.381-.37 1.02t.37 1.029q.379.381.96.381zM21.806
          20.146v.655h-2.628v-.655h.884v-4.38h-.884v-.656h1.71v5.036zM27.412
          20.721q-.286.158-.632.158-.395
          0-.64-.232-.244-.233-.278-.664-.42.456-.825.688-.404.233-.85.233-.658
          0-1.02-.432-.354-.431-.354-1.269v-1.66h-.792v-.655h1.618v2.29q0
          .465.193.722.203.249.64.249.65 0
          1.382-.805v-1.8h-.725v-.656h1.55v2.904q0 .406.287.406.168 0
          .26-.066zM36.41
          20.146v.655h-2.325v-.655h.716v-1.668q0-.431-.193-.68-.194-.249-.582-.249-.345
          0-.707.224t-.708.639v1.734h.725v.655H31.06v-.655h.725v-1.668q0-.431-.202-.68-.202-.249-.59-.249-.345
          0-.707.232-.363.224-.716.647v1.718h.732v.655h-2.45v-.655h.892v-2.597h-.893v-.655h1.719v.854q.37-.456.808-.705.438-.249.91-.249.48
          0 .8.266.329.257.455.763.379-.49.825-.755.455-.274.944-.274.615 0
          .96.431.354.424.354 1.228v1.693zM42.556
          20.146v.655h-2.341v-.655h.733v-1.618q0-.456-.236-.714-.228-.265-.657-.265-.733
          0-1.55.912v1.685h.733v.655h-2.451v-.655h.893v-2.597h-.893v-.655h1.718v.92q.472-.514.901-.763.438-.257.935-.257.682
          0 1.053.431.37.432.37 1.278v1.643zM47.635
          20.701q-.278.166-.649.166-.312
          0-.53-.174-.211-.182-.295-.514-.843.738-1.668.738-.581
          0-.986-.324t-.404-.904q0-.398.228-.688.227-.299.606-.448.387-.158.834-.158.379
          0 .699.075.32.066.657.199v-.365q0-.423-.286-.622-.287-.2-.75-.2-.657
          0-1.584.357l-.168-.63q.994-.415 1.853-.415.817 0 1.263.398.455.39.455
          1.145v1.435q0 .407.295.407.126 0 .261-.067zm-3.715-1.053q0
          .282.228.44.227.149.556.149.286 0
          .656-.15.371-.149.767-.44v-.439q-.573-.199-1.213-.216-.413
          0-.707.175-.287.166-.287.48z" />
      </g>
      <g fill="#1aaded" stroke-width=".3517" aria-label="VITAE">
        <path
          d="m18.3 24.324h-1.06l-2.754
          4.933h-0.867l-2.733-4.933h-1.06v-1.094h3.681v1.095h-0.928l1.58 3.096
          1.52-3.096h-1.03v-1.095h3.651zm3.487
          0v3.726h1.152v1.095h-3.947v-1.095h1.142v-3.726h-1.142v-1.094h3.947v1.095zm9.303-1.104v2.278h-1.438v-1.182h-1.489v3.726h1.112v1.095h-3.885v-1.095h1.121v-3.726h-1.499v1.182h-1.438v-2.278zm8.224
          4.829v1.095h-3.569v-1.095h1.03l-0.388-0.863h-2.56l-0.377
          0.863h1.132v1.095h-3.498v-1.095h0.826l1.877-3.735h-0.724v-1.087h4.232v1.087h-0.714l1.887
          3.735zm-3.354-1.829-0.846-1.906h-0.01l-0.847
          1.906zm9.814-0.792v-1.104h-3.03v1.44h1.071v-0.681h1.214v2.346h-1.214v-0.682h-1.07v1.303h3.029v-1.104h1.437v2.199h-7.22v-1.095h1.132v-3.726h-1.132v-1.096h7.22v2.2z" />
      </g>
    </svg>
  </header>
  
  <nav>
    <ul>
      <li>
        <a href="javascript:;" id="language" on:click={changeLang}>{idioma}</a>
      </li>
      <li>
        <a href="#metodo" on:click={animarLogo}>{texto[idioma].nav.one}</a>
      </li>
      <li>
        <a href="#videos" on:click={animarLogo}>{texto[idioma].nav.two}</a>
      </li>
      <li>
        <a href="#equipo" on:click={animarLogo}>{texto[idioma].nav.three}</a>
      </li>
      <li>
        <a href="#contacto">{texto[idioma].nav.four}</a>
      </li>
      

    </ul>
  </nav>

  <h3 class="quote1">
    {texto[idioma].quote1}
    <br />
    <em>~ Dr. Carlos Mario Fiore</em>
  </h3>

  <aside />

  <main />

  <section id="metodo">
    <h1>{texto[idioma].method.title}</h1>
    <br />
    <h2 class="topico">{texto[idioma].method.sub1.title}</h2>
    <br />
    <p>{texto[idioma].method.sub1.p1}
      <br />
      <br />
      {texto[idioma].method.sub1.p2}
      <br />
    </p>
    <p class="aclaratorio">
      {texto[idioma].method.sub1.aclaratorio}
      <span class="bold">{texto[idioma].method.sub1.bold}</span>
      <br />
    </p>
    <h2 class="topico">{texto[idioma].method.sub2.title}</h2>
    <br />
    <p>
      {texto[idioma].method.sub2.p1}
      <br />
      <br />
      {texto[idioma].method.sub2.p2}
      <br />
      <br />
      {texto[idioma].method.sub2.p3}
      <br />
      <br />
      {texto[idioma].method.sub2.p4}
      <br />
      <br />
      {texto[idioma].method.sub2.p5}
      <br />
    </p>
    <div>
      <p>
        {texto[idioma].method.sub2.p6A}
        <em>{texto[idioma].method.sub2.p6Em}</em>
        {texto[idioma].method.sub2.p6B}
      </p>
      <p class="aclaratorio">
        <em>
          <span class="bold">{texto[idioma].method.sub2.aclaratorioSpan}</span>
          {texto[idioma].method.sub2.aclaratorioP}
        </em>
      </p>
      <br />
    </div>
    <h2 class="quote">{texto[idioma].quote2}</h2>
    <h2 class="topico">{texto[idioma].method.sub3.title}</h2>
    <br />
    <ul>
      <li>{texto[idioma].method.sub3.b1}</li>
      <li>{texto[idioma].method.sub3.b2}</li>
      <li>{texto[idioma].method.sub3.b3}</li>
    </ul>
    <ul>
      <li>{texto[idioma].method.sub3.b4}</li>
      <li>{texto[idioma].method.sub3.b5}</li>
      <li>{texto[idioma].method.sub3.b6}</li>
      <br />
    </ul>
    <h3 class="subtitulo">{texto[idioma].method.sub4.title}</h3>
    <br />
    <div>
      <p>{texto[idioma].method.sub4.p1}</p>
      <ul>
        <li>{texto[idioma].method.sub4.b1}</li>
        <li>{texto[idioma].method.sub4.b2}</li>
      </ul>
    </div>
    <ul>
      <li>{texto[idioma].method.sub4.b3}</li>
      <li>{texto[idioma].method.sub4.b4}</li>
      <br />
    </ul>

    <h2 class="quote">{texto[idioma].quote3}</h2>

    <h2 class="topico">{texto[idioma].method.sub5.title}</h2>
    <br />
    <h3 class="subtitulo">{texto[idioma].method.sub5.subtitle}</h3>
    <br />
    <ul>
      <li>{texto[idioma].method.sub5.b1}</li>
      <li>{texto[idioma].method.sub5.b2}</li>
      <li>{texto[idioma].method.sub5.b3}</li>
      <li>{texto[idioma].method.sub5.b4}</li>
      <li>{texto[idioma].method.sub5.b5}</li>
      <li>{texto[idioma].method.sub5.b6}</li>
      <li>{texto[idioma].method.sub5.b7}</li>
      <li>{texto[idioma].method.sub5.b8}</li>
      <li>{texto[idioma].method.sub5.b9}</li>
      <li>{texto[idioma].method.sub5.b10}</li>
    </ul>
    <ul>
      <li>{texto[idioma].method.sub5.b11}</li>
      <li>{texto[idioma].method.sub5.b12}</li>
      <li>{texto[idioma].method.sub5.b13}</li>
      <li>{texto[idioma].method.sub5.b14}</li>
      <li>{texto[idioma].method.sub5.b15}</li>
      <li>{texto[idioma].method.sub5.b16}</li>
      <li>{texto[idioma].method.sub5.b17}</li>
      <br />
    </ul>
    <br />
  </section>

  <section id="videos">
    <h1 style="width: 100%;">{texto[idioma].videos}</h1>
    <br />
    
    <iframe
      title="Congreso Internacional de Medicina Tibetana 2007"
      type="text/html"
      width="320"
      height="240"
      src="https://www.youtube.com/embed/vYNtrsLTbaw?rel=0&modestbranding=1"
      frameborder="0"
      allowfullscreen 
      seamless/>

    <iframe
      title="Codo de Tenista"
      type="text/html"
      width="320"
      height="240"
      src="https://www.youtube.com/embed/33MD93lt6wI?rel=0&modestbranding=1"
      frameborder="0"
      allowfullscreen 
      seamless/>

     <iframe
      title="Seminario 2005"
      type="text/html"
      width="320"
      height="240"
      src="https://www.youtube.com/embed/k1SNaBL1gH0?rel=0&modestbranding=1"
      frameborder="0"
      allowfullscreen 
      seamless/>

    <iframe
      title="Dedo en Resorte"
      type="text/html"
      width="320"
      height="240"
      src="https://www.youtube.com/embed/l8Yo4KOzNDk?rel=0&modestbranding=1"
      frameborder="0"
      allowfullscreen 
      seamless/>

    <iframe
      title="Juanete"
      type="text/html"
      width="320"
      height="240"
      src="https://www.youtube.com/embed/RM4RlRZJBJ4?rel=0&modestbranding=1"
      frameborder="0"
      allowfullscreen 
      seamless/>

    <iframe
      title="Pie Plano"
      type="text/html"
      width="320"
      height="240"
      src="https://www.youtube.com/embed/uJ5veTpMSf4?rel=0&modestbranding=1"
      frameborder="0"
      allowfullscreen 
      seamless/>

    <iframe
      title="Escoliosis"
      type="text/html"
      width="320"
      height="240"
      src="https://www.youtube.com/embed/EfffQKwwxpc?rel=0&modestbranding=1"
      frameborder="0"
      allowfullscreen 
      seamless/>

    <iframe
      title="Manguito Rotador"
      type="text/html"
      width="320"
      height="240"
      src="https://www.youtube.com/embed/qbiciPfe4iE?rel=0&modestbranding=1"
      frameborder="0"
      allowfullscreen 
      seamless/>

    <iframe
      title="Retrolistesis Sacra"
      type="text/html"
      width="320"
      height="240"
      src="https://www.youtube.com/embed/ETrQ61PMJes?rel=0&modestbranding=1"
      frameborder="0"
      allowfullscreen 
      seamless/>
    
    <iframe
      title={videos[idioma][0].title}
      type="text/html"
      width="320"
      height="240"
      src={videos[idioma][0].link}
      frameborder="0"
      allowfullscreen 
      seamless/>
    
    <iframe
      title={videos[idioma][1].title}
      type="text/html"
      width="320"
      height="240"
      src={videos[idioma][1].link}
      frameborder="0"
      allowfullscreen 
      seamless/>
  </section>

  <section id="equipo">
    <h1>{texto[idioma].team.title}</h1>
    <br />
    <div>
      <h3>{texto[idioma].team.fioreName}</h3>
      <p><em>{texto[idioma].team.fioreTitle}</em></p>
      <p>{texto[idioma].team.fioreText}
      </p>
    </div>
    <div>
      <h3>{texto[idioma].team.marcosName}</h3>
      <p><em>{texto[idioma].team.marcosTitle}</em></p>
      <p>{texto[idioma].team.marcosText}</p>
    </div>
  </section>

  <section id="contacto">
    <h1>{texto[idioma].contact.title}</h1>
    <p>{texto[idioma].contact.p1}
      <br />
    </p>
    <br />
    <p>{texto[idioma].contact.p2A}
      <a href="mailto:columnavitae.spine@gmail.com">{texto[idioma].contact.p2Link}</a>
      {texto[idioma].contact.p2B}
      <br />
      {texto[idioma].contact.p3}
    </p>
    <br />
    <br />
    <p class="centrado bold">
      {texto[idioma].contact.bold}
      <br />
      {texto[idioma].contact.phone}
    </p>
    <p class="centrado letrachica">
      {texto[idioma].contact.horarioA}
      <br />
      {texto[idioma].contact.horarioB}
    </p>

    <form
      action="https://formspree.io/columnavitae.spine@gmail.com"
      method="POST">
      <div id="campos">
        <div id="nom">
          <label for="nombre">{texto[idioma].form.name}</label>
          <input
            type="text"
            id="nombre"
            name="Nombre"
            required
            oninvalid="this.setCustomValidity('Complete su nombre')" />
          <br />
        </div>
        <div id="ape">
          <label for="apellido">{texto[idioma].form.lastName}</label>
          <input
            type="text"
            id="apellido"
            name="Apellido"
            required
            oninvalid="this.setCustomValidity('Complete su apellido')" />
          <br />
        </div>
        <div id="ema">
          <label for="clientemail">Email</label>
          <input
            type="email"
            id="clientemail"
            name="Email"
            required
            oninvalid="this.setCustomValidity('Ingrese un email válido')" />
          <br />
        </div>
        <div id="tel">
          <label for="telefono">{texto[idioma].form.phone}</label>
          <input
            type="tel"
            id="telefono"
            name="Telefono"
            placeholder="(código de área en paréntesis)" />
          <br />
        </div>
        <div id="tex">
          <label for="consulta">{texto[idioma].form.text}</label>
          <br />
          <textarea
            id="consulta"
            type="text"
            rows="7"
            cols="45"
            name="Consulta"
            required
            oninvalid="this.setCustomValidity('Ingrese su consulta')" />
          <br />
          <br />
          <label style="text-align:left; margin: auto;">
            <input
              type="checkbox"
              id="email_list"
              name="Subscribir"
              checked
              style="width: 15px; padding: 0px 10px 0px 0px; margin-left: 0px;" />
            {texto[idioma].form.optionText}
          </label>
        </div>
      </div>

      <button type="submit">{texto[idioma].form.send}</button>
    </form>
  </section>

  <footer>
    <p style="text-align:center;letter-spacing:.5em;margin-top:-20px;">Compartir en:</p>
    <div>
      <a href="https://www.instagram.com/columnavitae_marcos/"
        target="blank" rel="noopener noreferrer">
        <svg id="instagram" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M336 96c21.2 0 41.3 8.4 56.5 23.5S416 154.8 416 176v160c0 21.2-8.4 41.3-23.5 56.5S357.2 
        416 336 416H176c-21.2 0-41.3-8.4-56.5-23.5S96 357.2 96 336V176c0-21.2 8.4-41.3 23.5-56.5S154.8 96 
        176 96h160m0-32H176c-61.6 0-112 50.4-112 112v160c0 61.6 50.4 112 112 112h160c61.6 0 112-50.4 
        112-112V176c0-61.6-50.4-112-112-112z"/><path d="M360 176c-13.3 0-24-10.7-24-24s10.7-24 24-24c13.2 
        0 24 10.7 24 24s-10.8 24-24 24zM256 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 
        28.7-64 64-64m0-32c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"/>
        </svg>
      </a>
      <a href="https://www.facebook.com/sharer.php?u=https%3A%2F%2Fwww.columna-vitae.com%2F"
        target="blank" rel="noopener noreferrer">
        <svg id="facebook" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M426.8 64H85.2C73.5 64 64 73.5 64 85.2v341.6c0 11.7 9.5 21.2 21.2 
        21.2H256V296h-45.9v-56H256v-41.4c0-49.6 34.4-76.6 78.7-76.6 21.2 0 44 1.6 49.3 
        2.3v51.8h-35.3c-24.1 0-28.7 11.4-28.7 28.2V240h57.4l-7.5 56H320v152h106.8c11.7 0 
        21.2-9.5 21.2-21.2V85.2c0-11.7-9.5-21.2-21.2-21.2z" />
        </svg>
      </a>
      <a href="https://plus.google.com/share?url=https%3A%2F%2Fwww.columna-vitae.com%2F"
        target="blank" rel="noopener noreferrer">
        <svg id="googlep" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M318.2 230.9l-1.6-7H160V288h90.7c-9.4 45-48.4 63.6-84.1 63.6-26 
          0-50.2-7.8-68.3-25.3-18.6-18.1-28.9-43.1-28.9-70.4 0-27.1 9.8-51.8 27.6-69.6 17.7-17.7 
          42-25.4 68.7-25.4 30.5 0 49.9 13.8 58.1 21.1l48-47.7C258.3 122.6 221.5 93 164.1 93c-44.3 
          0-86.7 16.8-117.7 47.8C15.9 171.3 0 215.2 0 256s15 82.6 44.6 113.3C76.3 402 121.2 419 
          167.5 419c42.1 0 81.9-16.5 110.3-46.3 28-29.4 42.4-70.1 42.4-112.7-.1-18-1.9-28.7-2-29.1zM512 
          224h-57v-57h-41v57h-57v41h57v57h41v-57h57z" />
        </svg>
      </a>
      <a href="https://twitter.com/intent/tweet?url=https%3A%2F%2Fwww.columna-vitae.com%2F"
        target="blank" rel="noopener noreferrer">
        <svg id="twitter" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M492 109.5c-17.4 7.7-36 12.9-55.6 15.3 20-12 35.4-31 42.6-53.6-18.7 11.1-39.4 
        19.2-61.5 23.5C399.8 75.8 374.6 64 346.8 64c-53.5 0-96.8 43.4-96.8 96.9 0 7.6.8 15 2.5 
        22.1-80.5-4-151.9-42.6-199.6-101.3-8.3 14.3-13.1 31-13.1 48.7 0 33.6 17.2 63.3 43.2 
        80.7-16-.4-31-4.8-44-12.1v1.2c0 47 33.4 86.1 77.7 95-8.1 2.2-16.7 3.4-25.5 3.4-6.2 
        0-12.3-.6-18.2-1.8 12.3 38.5 48.1 66.5 90.5 67.3-33.1 26-74.9 41.5-120.3 41.5-7.8 
        0-15.5-.5-23.1-1.4C62.8 432 113.7 448 168.3 448 346.6 448 444 300.3 444 
        172.2c0-4.2-.1-8.4-.3-12.5C462.6 146 479 129 492 109.5z" />
        </svg>
      </a>
      <a href="https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fwww.columna-vitae.com%2F"
        target="blank" rel="noopener noreferrer">
        <svg id="linkedin" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M417.2 64H96.8C79.3 64 64 76.6 64 93.9V415c0 17.4 15.3 32.9 32.8 32.9h320.3c17.6 
        0 30.8-15.6 30.8-32.9V93.9C448 76.6 434.7 64 417.2 64zM183 384h-55V213h55v171zm-25.6-197h-.4c-17.6 
        0-29-13.1-29-29.5 0-16.7 11.7-29.5 29.7-29.5s29 12.7 29.4 29.5c0 16.4-11.4 29.5-29.7 
        29.5zM384 384h-55v-93.5c0-22.4-8-37.7-27.9-37.7-15.2 0-24.2 10.3-28.2 20.3-1.5 3.6-1.9 8.5-1.9 
        13.5V384h-55V213h55v23.8c8-11.4 20.5-27.8 49.6-27.8 36.1 0 63.4 23.8 63.4 75.1V384z" />
        </svg>
      </a>
      <a href="https://pinterest.com/pin/create/button/?url=https%3A%2F%2Fwww.columna-vitae.com%2F"
        target="blank" rel="noopener noreferrer">  
        <svg id="pinterest" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M256 32C132.3 32 32 132.3 32 256c0 91.7 55.2 170.5 134.1 205.2-.6-15.6-.1-34.4 3.9-51.4 4.3-18.2 28.8-122.1 28.8-122.1s-7.2-14.3-7.2-35.4c0-33.2 19.2-58 43.2-58 20.4 0 30.2 15.3 30.2 33.6 0 20.5-13.1 51.1-19.8 79.5-5.6 23.8 11.9 43.1 35.4 43.1 42.4 0 71-54.5 71-119.1 0-49.1-33.1-85.8-93.2-85.8-67.9 0-110.3 50.7-110.3 107.3 0 19.5 5.8 33.3 14.8 43.9 4.1 4.9 4.7 6.9 3.2 12.5-1.1 4.1-3.5 14-4.6 18-1.5 5.7-6.1 7.7-11.2 5.6-31.3-12.8-45.9-47-45.9-85.6 0-63.6 53.7-139.9 160.1-139.9 85.5 0 141.8 61.9 141.8 128.3 0 87.9-48.9 153.5-120.9 153.5-24.2 0-46.9-13.1-54.7-27.9 0 0-13 51.6-15.8 61.6-4.7 17.3-14 34.5-22.5 48 20.1 5.9 41.4 9.2 63.5 9.2 123.7 0 224-100.3 224-224C480 132.3 379.7 32 256 32z" />
        </svg>
      </a>
      <!-- <a href="https://www.tumblr.com/share/link?url=https%3A%2F%2Fwww.columna-vitae.com%2F" 
        target="blank" rel="noopener noreferrer">
        <svg id="tumblr" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M321.2 396.3c-11.8 0-22.4-2.8-31.5-8.3-6.9-4.1-11.5-9.6-14-16.4-2.6-6.9-3.6-22.3-3.6-46.4V224h96v-64h-96V48h-61.9c-2.7 21.5-7.5 44.7-14.5 58.6-7 13.9-14 25.8-25.6 35.7-11.6 9.9-25.6 17.9-41.9 23.3V224h48v140.4c0 19 2 33.5 5.9 43.5 4 10 11.1 19.5 21.4 28.4 10.3 8.9 22.8 15.7 37.3 20.5 14.6 4.8 31.4 7.2 50.4 7.2 16.7 0 30.3-1.7 44.7-5.1 14.4-3.4 30.5-9.3 48.2-17.6v-65.6c-20.9 13.7-41.8 20.6-62.9 20.6z" />
        </svg>
      </a> -->
    </div>
    © 2008-2020 ~ CV Columna Vitae
    <br />
    Dr. Carlos Mario Fiore |
    <button
      on:click={() => {
        showPrivacy = !showPrivacy;
      }}>política de privacidad
    </button>
    <br />
    <a href="https://www.columnavitae.com" style="color:white;">
      columnavitae
    </a>
    y
    <a href="https://www.columna-vitae.com" style="color:white;">
      columna-vitae
    </a>
    <br />
    <span>webmaster alelubos</span>

    <a href="#top">
      <svg id="up" version="1.1" xmlns="http://www.w3.org/2000/svg" alt="Go to the Top" viewBox="0 0 512 512"> 
        <path d="M412.6 227.1L278.6 89c-5.8-6-13.7-9-22.4-9h-.4c-8.7 0-16.6 3-22.4 9l-134 138.1c-12.5 
        12-12.5 31.3 0 43.2 12.5 11.9 32.7 11.9 45.2 0l79.4-83v214c0 16.9 14.3 30.6 32 30.6 18 0 
        32-13.7 32-30.6v-214l79.4 83c12.5 11.9 32.7 11.9 45.2 0s12.5-31.2 0-43.2z" />
      </svg>
    </a>

  </footer>

  <Privacy {showPrivacy} on:click={() => (showPrivacy = !showPrivacy)} />

</div>

<style>
  .bold {
    font-weight: bold;
  }
/*   .celeste {
    color: rgba(26, 173, 237);
  }
*/
  .centrado {
    text-align: center;
    color: black;
  }
  .letrachica {
    font-size: 0.9rem;
  }
</style>